<template>
  <span class="text-body-2 text-high-emphasis">
    <slot />
  </span>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'SfSecondaryText'
})
</script>
